import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start User
export const getUsersAdminService = (params) => {
  return http.get(`${base_url}/admin/users`, { params });
};
export const createUserAdminService = (data) => {
  return http.post(`${base_url}/admin/user`, data);
};
export const editUserAdminService = (data) => {
  return http.put(`${base_url}/admin/user/${data.id}`, data);
};
export const changeUserConfirmAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/confirm`);
};
export const changeUserPasswordAdminService = (data) => {
  return http.patch(`${base_url}/admin/user/${data.id}/change-password`, data);
};
export const deleteUserAdminService = (id) => {
  return http.delete(`${base_url}/admin/user/${id}`);
};
export const verifyUserPhoneNumberAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/phone-number`);
};
export const verifyUserEmailAdminService = (id) => {
  return http.patch(`${base_url}/admin/user/${id}/verify/email`);
};
export const getUserTokenAdminService = (id) => {
  return http.get(`${base_url}/admin/user/${id}/token`);
};
// End User

// Start Transaction
export const createTransactionAdminService = (data) => {
  return http.post(`${base_url}/admin/transaction`, data);
};
export const editTransactionAdminService = (data) => {
  return http.put(`${base_url}/admin/transaction/${data.id}`, data);
};
// End Transaction

// Start Setting
export const getSettingAdminService = (params) => {
  return http.get(`${base_url}/admin/setting`, { params });
};
export const editSettingAdminService = (data) => {
  return http.put(`${base_url}/admin/setting`, data);
};
// End Setting

// Start Log
export const getLogsAdminService = (params) => {
  return http.get(`${base_url}/admin/log`, { params });
};
export const deleteAllLogAdminService = () => {
  return http.delete(`${base_url}/admin/log`);
};
export const deleteLogAdminService = (id) => {
  return http.delete(`${base_url}/admin/log/${id}`);
};
// End Log

// Start Geo
export const createGeoAdminService = (data) => {
  return http.post(`${base_url}/admin/geo`, data);
};
export const editGeoAdminService = (data) => {
  return http.put(`${base_url}/admin/geo/${data.id}`, data);
};
export const deleteGeoAdminService = (id) => {
  return http.delete(`${base_url}/admin/geo/${id}`);
};
// End Geo

// Start Category
export const getCategoriesAdminService = (params) => {
  return http.get(`${base_url}/admin/category`, { params });
};
export const createCategoryAdminService = (data) => {
  return http.post(`${base_url}/admin/category`, data);
};
export const editCategoryAdminService = (data) => {
  return http.put(`${base_url}/admin/category/${data.id}`, data);
};
export const deleteCategoryAdminService = (id) => {
  return http.delete(`${base_url}/admin/category/${id}`);
};
export const changeCategoryActiveAdminService = (id) => {
  return http.patch(`${base_url}/admin/category/${id}/active`);
};
// End Category

// Start Field
export const getFieldsAdminService = (params) => {
  return http.get(`${base_url}/admin/fields`, { params });
};
export const createFieldAdminService = (data) => {
  return http.post(`${base_url}/admin/field`, data);
};
export const editFieldAdminService = (data) => {
  return http.put(`${base_url}/admin/field/${data.id}`, data);
};
export const deleteFieldAdminService = (id) => {
  return http.delete(`${base_url}/admin/field/${id}`);
};
// End Field

// Start Product
export const getProductsAdminService = (params) => {
  return http.get(`${base_url}/admin/products`, { params });
};
export const createProductAdminService = (data) => {
  return http.post(`${base_url}/admin/product`, data);
};
export const editProductAdminService = (data) => {
  return http.put(`${base_url}/admin/product/${data.id}`, data);
};
export const changeProductActiveAdminService = (id) => {
  return http.patch(`${base_url}/admin/product/${id}/active`);
};
export const deleteProductAdminService = (id) => {
  return http.delete(`${base_url}/admin/product/${id}`);
};
// End Product

// Start Discount Code
export const getDiscountCodesAdminService = (params) => {
  return http.get(`${base_url}/admin/discount-codes`, { params });
};
export const createDiscountCodeAdminService = (data) => {
  return http.post(`${base_url}/admin/discount-code`, data);
};
export const editDiscountCodeAdminService = (data) => {
  return http.put(`${base_url}/admin/discount-code/${data.id}`, data);
};
export const deleteDiscountCodeAdminService = (id) => {
  return http.delete(`${base_url}/admin/discount-code/${id}`);
};
export const changeDiscountCodeActiveAdminService = (id) => {
  return http.patch(`${base_url}/admin/discount-code/${id}/active`);
};
// End Discount Code

// Start Invoice
export const createInvoiceAdminService = (data) => {
  return http.post(`${base_url}/admin/invoice`, data);
};
export const editInvoiceAdminService = (data) => {
  return http.put(`${base_url}/admin/invoice/${data.id}`, data);
};
export const deleteInvoiceAdminService = (id) => {
  return http.delete(`${base_url}/admin/invoice/${id}`);
};
// End Invoice

// Start Renewal
export const deleteRenewalAdminService = (id) => {
  return http.delete(`${base_url}/admin/renewal/${id}`);
};
// End Renewal

// Start FAQ
export const getFAQsAdminService = (params) => {
  return http.get(`${base_url}/admin/faqs`, { params });
};
export const createFAQAdminService = (data) => {
  return http.post(`${base_url}/admin/faq`, data);
};
export const editFAQAdminService = (data) => {
  return http.put(`${base_url}/admin/faq/${data.id}`, data);
};
export const deleteFAQAdminService = (id) => {
  return http.delete(`${base_url}/admin/faq/${id}`);
};
// End FAQ

// Start Bulk SMS
export const getBulkSMSsAdminService = (params) => {
  return http.get(`${base_url}/admin/bulk-sms`, { params });
};
export const createBulkSMSAdminService = (data) => {
  return http.post(`${base_url}/admin/bulk-sms`, data);
};
export const editBulkSMSAdminService = (data) => {
  return http.put(`${base_url}/admin/bulk-sms/${data.id}`, data);
};
export const deleteBulkSMSAdminService = (id) => {
  return http.delete(`${base_url}/admin/bulk-sms/${id}`);
};
// End Bulk SMS
